export default "__VITE_ASSET__DYmGuf77__"